import React from 'react';
import { delay } from 'helpers';
import { connect } from 'react-redux';
import { scroller, animateScroll } from 'react-scroll';
import { filterVisibleSections } from 'helpers';

import * as selectors from 'selectors';
import * as actions from 'actions';
import * as Modules from 'components/modules';

import styles from './agency.css';

const sectionsMap = {
  text: Modules.TextSection,
  textMedia: Modules.TextMediaSection,
  textImage: Modules.TextImageSection,
  career: Modules.FlipperSection,
  sliderDesktop: Modules.SliderDesktopSection,
  sliderMobile: Modules.SliderMobileSection,
  sliderFullscreen: Modules.SliderFullscreenSection,
  note: Modules.NoteSection,
  video: Modules.VideoSection,
  about: Modules.About,
  contacts: Modules.Contacts,
  crew: Modules.Crew,
  awards: Modules.AwardsSection,
  clients: Modules.AwardsSection,
};

class Agency extends React.Component {
  state = {
    scroll: 0,
    visibleSections: filterVisibleSections(this.props.agency, sectionsMap),
  };

  componentDidMount() {
    const { anchor, setPageReady } = this.props;
    delay(3000)
      .then(setPageReady)
      .catch(console.log);
    const anchorElem = document.getElementById(anchor);
    anchorElem
      ? anchorElem.scrollIntoView({ behavior: 'instant', block: 'start' })
      : (document.getElementById('wrapper').scrollTop = 0);
  }
  componentDidUpdate() {
    const { anchor } = this.props;
    const anchorElem = document.getElementById(anchor);
    anchorElem
      ? anchorElem.scrollIntoView({ behavior: 'instant', block: 'start' })
      : (document.getElementById('wrapper').scrollTop = 0);
  }
  render() {
    const { agency, pathname } = this.props;
    const { visibleSections } = this.state;
    const metaSection = agency.find(section => section && section.type === 'meta');
    return (
      <div className={styles.root} id="worksRoot">
        {agency && (
          <React.Fragment>
            <Modules.Meta {...metaSection} />
            {visibleSections.map((sectionItem, i) => {
              const Section = sectionsMap[sectionItem.type];
              return (
                <Modules.VisibilitySensor
                  color={sectionItem.colors.logo}
                  id={`section-${i}`}
                  key={`${pathname}${i}`}
                  scrollIndex={i}
                >
                  <Section
                    {...sectionItem}
                    scrollIndex={i}
                    id={sectionItem.id}
                  />
                </Modules.VisibilitySensor>
              );
            })}
          </React.Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  agency: state.data.agency,
  pathname: state.location.pathname,
  meta: selectors.getStaticMeta(state),
  anchor: state.location.payload.anchor,
});

const mapDispatch = dispatch => ({
  setPageReady: () => dispatch(actions.setPageReady()),
});

Agency.defaultProps = {
  meta: {},
};

export default connect(mapStateToProps, mapDispatch)(Agency);



// WEBPACK FOOTER //
// ./src/components/screens/Agency/Agency.js